module.exports = __webpack_public_path__ + "img/tutorial-shortcut.e15e154c.png";